"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewGroupsSelector = void 0;
var _Modal = require("../../../Layout/Modal");
var _Button = require("../../../UI/Button");
var _hooks = require("../../../hooks");
var _AudiencePicker = require("../AudiencePicker.labels");
var _GroupsAndClassesSelection = require("./partials/GroupsAndClassesSelection");
var _jsxRuntime = require("react/jsx-runtime");
const ViewGroupsSelector = props => {
  const {
    setViewAndIndex,
    selectedGroupsIds,
    selectedClassesIds = [],
    selectedStudentsIds,
    groupsSelectorTempData,
    onSelectedChanged,
    setGroupsSelectorTempData
  } = props;
  const getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  const handleGroupsSelectorTempDataChanged = newSelectData => {
    setGroupsSelectorTempData({
      selectedGroupsIds: [...(newSelectData.selectedGroupsIds || [])],
      selectedClassesIds: [...(newSelectData.selectedClassesIds || [])]
    });
  };
  const hasChanges = selectedGroupsIds?.length !== groupsSelectorTempData?.selectedGroupsIds?.length || groupsSelectorTempData && groupsSelectorTempData.selectedGroupsIds.filter(id => selectedGroupsIds && selectedGroupsIds.indexOf(id) < 0).length > 0 || selectedClassesIds?.length !== groupsSelectorTempData?.selectedClassesIds?.length || groupsSelectorTempData && groupsSelectorTempData.selectedClassesIds.filter(id => selectedClassesIds && selectedClassesIds.indexOf(id) < 0).length > 0;
  const handleCancel = () => {
    setViewAndIndex('inline', 0);
  };
  const handleConfirm = () => {
    if (hasChanges && onSelectedChanged) {
      onSelectedChanged({
        selectedGroupsIds: [...(groupsSelectorTempData && groupsSelectorTempData.selectedGroupsIds || [])],
        selectedClassesIds: [...(groupsSelectorTempData && groupsSelectorTempData.selectedClassesIds || [])],
        selectedStudentsIds: selectedStudentsIds
      });
    }
    setViewAndIndex('inline', 0);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel('groupsSelector_offset_title')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GroupsAndClassesSelection.GroupsAndClassesSelection, {
        ...props,
        onSelectedChanged: handleGroupsSelectorTempDataChanged,
        selectedGroupsIds: groupsSelectorTempData && groupsSelectorTempData.selectedGroupsIds || [],
        selectedClassesIds: groupsSelectorTempData && groupsSelectorTempData.selectedClassesIds || []
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          onClick: handleCancel,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          onClick: handleConfirm,
          isDisabled: !hasChanges,
          children: getLabel('confirm')
        })
      })]
    })]
  });
};
exports.ViewGroupsSelector = ViewGroupsSelector;